// Keep in sync with server/app/personal_email.py
const PERSONAL_EMAIL_DOMAINS = [
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.uk",
  "yahoo.nl",
  "hotmail.com",
  "hotmail.nl",
  "hotmail.co.uk",
  "outlook.com",
  "outlook.nl",
  "live.com",
  "live.nl",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "mail.com",
  "ymail.com",
  "rocketmail.com",
  "gmx.com",
  "gmx.net",
  "ziggo.nl",
  "kpnmail.nl",
  "hetnet.nl",
  "planet.nl",
] as const;

const PERSONAL_EMAIL_MESSAGE = "Personal email addresses are not accepted.";

export class PersonalEmailDomain {
  isPersonal(email: string): boolean {
    const host = this.hostOf(email);
    if (!host) return false;
    return PERSONAL_EMAIL_DOMAINS.some(
      (domain) => host === domain || host.endsWith(`.${domain}`),
    );
  }

  rejectReason(email: string): string | null {
    return this.isPersonal(email) ? PERSONAL_EMAIL_MESSAGE : null;
  }

  private hostOf(email: string): string | null {
    const at = email.lastIndexOf("@");
    if (at < 0 || at === email.length - 1) return null;
    return email.slice(at + 1).trim().toLowerCase();
  }
}

export class ExtractedEmailMapper {
  constructor(private readonly personal = new PersonalEmailDomain()) {}

  firstBusinessEmail(text: string): string | undefined {
    const matches = text.match(/[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}/g);
    if (!matches) return undefined;
    for (const email of matches) {
      if (!this.personal.isPersonal(email)) return email;
    }
    return undefined;
  }
}
